import { UpdateMediaDevicesFunction } from 'hooks/useMediaDevices';
import { getUserMedia } from 'features/user-media/utils/getUserMedia';
import webrtcAdapter from 'webrtc-adapter';
import {
  enumerateDevices,
  getBaseMediaConstraints,
  stopStreamTracks,
} from 'features/user-media/utils';

interface RefineMediaDevicesOptions {
  permissions?: { audio: boolean; video: boolean };
}

// Browsers reveal a valid device list only after granting permissions
export const refineMediaDevices = async (
  updateMediaDevices: UpdateMediaDevicesFunction,
  options: RefineMediaDevicesOptions = {}
) => {
  const permissions = options.permissions ?? { audio: true, video: true };

  const { browserDetails } = webrtcAdapter;
  const requestUserMedia = async () => {
    const updatedMediaDevices = await enumerateDevices();
    const constraints: MediaStreamConstraints = getBaseMediaConstraints(
      updatedMediaDevices,
      permissions
    );

    const stream = await getUserMedia(constraints);
    const mediaDevices = await updateMediaDevices({
      updatePermissions: true,
    });

    stopStreamTracks(stream);

    return mediaDevices;
  };

  if (
    browserDetails.browser === 'firefox' &&
    browserDetails.version !== undefined &&
    browserDetails.version < 132
  ) {
    return updateMediaDevices({
      updatePermissions: true,
    });
  }

  if (webrtcAdapter.browserDetails.browser === 'chrome') {
    return requestUserMedia();
  }

  return requestUserMedia();
};
